import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { map, catchError } from 'rxjs/operators';
import { BaseCrudService } from "projects/ProjetoBaseAngular/domain/services/base-crud.service";
import { MetaMsgTemplateModel } from "../models";

@Injectable({
  providedIn: 'root'
})
export class MetaMsgTemplateService extends BaseCrudService<MetaMsgTemplateModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'MetaMsgTemplate';
  }

  getMetaTemplates(): Observable<any[]> {
    return this.httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetMetaTemplates`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  importMetaTemplates(): Observable<MetaMsgTemplateModel[]> {
    return this.httpClient
      .post(`${this.getApiUrl()}${this.getController()}/ImportMetaTemplates`, null, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  getApprovedForSend(): Observable<MetaMsgTemplateModel[]> {
    return this.httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetApprovedForSend`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  publishToMeta(id: string): Observable<MetaMsgTemplateModel> {
    return this.httpClient
      .post(`${this.getApiUrl()}${this.getController()}/PublishToMeta/${id}`, null, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  getSendTemplateDetails(id: string): Observable<MetaMsgTemplateModel> {
    return this.httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetSendTemplateDetails/${id}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  sendTemplate(id: string, telefone: string, valoresParametros: { [key: string]: string }): Observable<string> {
    return this.httpClient
      .post(`${this.getApiUrl()}${this.getController()}/SendTemplate/${id}`, JSON.stringify({
        telefone,
        valoresParametros
      }), this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
